module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"datagrid":{"item_count":"no items | one item | {count} items","no_entries":"There are no entries for this data","start_by":"Start by","creating_cta":"creating a new entry","search":"Search","showing":"Showing {min} to {max} of {results}"}}}')
  delete Component.options._Ctor
}
